var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-pink is-medium"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container brrr"},[_c('span',{staticClass:"introText"},[_c('vue-markdown',{attrs:{"source":_vm.content.introText}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }